naiveShouldComponentUpdate = require 'app/scripts/lib/util/naive-should-component-update'
React = require 'react'
MemberAvatar = require 'app/scripts/views/member/member-avatar-react'
AutoCompleteMultiBoardGuestAlert = require 'app/scripts/views/organization/invite-member-autocomplete-multi-board-guest-alert'
t = require('app/scripts/views/internal/recup-with-helpers')('select_member')
l = require 'app/scripts/lib/localize'
{ trackUe } = require '@trello/analytics'
{ debounce } = require 'underscore'
{ TeamTestIds } = require '@trello/test-ids'
{ BoardInviteRestrictValues } = require 'app/scripts/views/organization/constants'

DisabledReasonsEnum = {
  JOINED: 'joined'
  INVITED: 'invited'
  BLOCKED: 'blocked'
  RESTRICT_ORG: 'org-restrict-org'
  RESTRICT_MANAGED: 'org-restrict-managed'
  RESTRICT_MANAGED_OR_ORG: 'org-restrict-managed-or-org'
}

module.exports = class AutocompleteMemberAvatar extends React.Component
  displayName: 'AutocompleteMemberAvatar'

  constructor: (props) ->
    super(props)
    @onRemoveClick = @onRemoveClick.bind(@)
    @onMouseDown = @onMouseDown.bind(@)
    @onMouseOver = debounce @onMouseOver.bind(@)
    @state =
      mgbAlertSeen: false

  getDisabledReason: ->
    { displayOrg, member } = @props

    if member.joined
      if member.memberType? == 'ghost'
        return DisabledReasonsEnum.INVITED
      return DisabledReasonsEnum.JOINED
    else if member.activityBlocked || member.isDeactivated
      return DisabledReasonsEnum.BLOCKED
    else if displayOrg && orgInviteRestrict = displayOrg.getPref('boardInviteRestrict')
      # This follows the code on server when you pass
      # onlyOrgOrManagedMembers: true
      # onlyOrgMembers: true
      # onlyManagedMembers: true
      # onlyLicensedOrManagedMembers: true
      # onlyLicensedMembers: true
      # to the api for search. We were previously not showing results via
      # sending those query params. But this confuesed users. So we don't
      # pass those, and instead disable the member based on same criteria.
      isInOrg = member.idOrganizations?.some((idOrg) => idOrg == displayOrg.get('id'))
      isInEnt = member.idEnterprise? && member.idEnterprise == displayOrg.get('idEnterprise')
      if orgInviteRestrict == BoardInviteRestrictValues.ORG
        return !isInOrg && DisabledReasonsEnum.RESTRICT_ORG
      else if orgInviteRestrict == BoardInviteRestrictValues.MANAGED
        return !isInEnt && DisabledReasonsEnum.RESTRICT_MANAGED
      else if orgInviteRestrict == BoardInviteRestrictValues.ORG_OR_MANAGED
        return !(isInOrg || isInEnt) && DisabledReasonsEnum.RESTRICT_MANAGED_OR_ORG

  render: t.renderable ->
    {
      member
      onRemoveClick,
      onMouseDown,
      displayDetails,
      displayOrg,
      displayUsername,
      activeMember,
      onShowMultiBoardGuestAlert,
      isDesktop,
    } = @props

    {
      active,
      username,
      email,
      confirmed,
      joined,
      fullName,
      idOrganizations,
      wouldBecomeBillableGuest,
      hasError,
      blockInvite,
    } = member

    disabledReason = @getDisabledReason()
    isClickable = @isClickable()

    if displayUsername
      title = "#{ fullName } (#{ username })"
    else
      title = fullName || email
      if title == username # if fullName was chosen, but it is not public
        title = "@#{title}"

    # using mousedown instead of click on the option allows us to
    # select the option and then have the input blur happen afterwards
    t.div '.autocomplete-option', {
      onMouseDown: @onMouseDown,
      onMouseOver: @onMouseOver,
      class: t.classify({
        disabled: !isClickable
        active: activeMember && isClickable
        'has-links': wouldBecomeBillableGuest && !disabledReason
        'has-error': hasError || blockInvite
      })
      'data-test-id': TeamTestIds.TeamInviteeOption
    }, =>
      t.div '.member-container', =>
        if displayDetails
          t.div '.member', { class: t.classify({ 'member-deactivated': member.activityBlocked }) }, =>
            t.createElement MemberAvatar, @props.member

        t.div '.member-info', ->
          t.div '.full-name', ->
            t.text title

          if displayOrg? && displayDetails && idOrganizations && displayOrg.id in idOrganizations
            t.span '.quiet.sub-name', {
              style:
                marginRight: 4
              }, ->
              t.text displayOrg.get('displayName')

          if displayDetails
            if disabledReason
              t.span '.quiet.sub-name', ->
                t.format disabledReason

          if displayDetails && !disabledReason
            if confirmed == false
              t.span '.quiet.sub-name', ->
                t.format 'unconfirmed-user'
            else if active == false
              t.span '.quiet.sub-name', ->
                t.format 'inactive-account'

        if onRemoveClick
          t.a '.icon-sm .icon-close', { onClick: @onRemoveClick, href: '#' }
      if @showMultiBoardGuestAlert()
        t.div '.multi-board-guest-autocomplete-alert', ->
          t.createElement AutoCompleteMultiBoardGuestAlert, { displayOrg, isDesktop }

  showMultiBoardGuestAlert: ->
    {
      onRemoveClick
      member
      displayOrg
    } = @props
    return (
      !onRemoveClick &&
      member.wouldBecomeBillableGuest &&
      !@getDisabledReason()?
    )

  isClickable: ->
    availableLicenseCount = @props.displayOrg?.getAvailableLicenseCount()

    return (
      !@getDisabledReason() && !@props.selected &&
      !(@props?.member?.wouldBecomeBillableGuest && (!@props.displayOrg?.owned() || @props?.isDesktop)) &&
      (
        (@props?.member?.wouldBecomeBillableGuest && availableLicenseCount > 0) ||
        (!@props?.member?.wouldBecomeBillableGuest)
      )
    )

  onMouseDown: (e) ->
    {
      onRemoveClick
      onShowMultiBoardGuestAlert
      member
    } = @props

    wasRemoveClicked = e.target.className.indexOf('icon-close') != -1

    # If this is a red lozenge, show the alert on click
    if onShowMultiBoardGuestAlert? && member.blockInvite && !wasRemoveClicked
      onShowMultiBoardGuestAlert(true)

    if !@isClickable()
      e.preventDefault()
    else if @props?.onMouseDown
      @props.onMouseDown(e)

  onMouseOver: (e) ->
    if !@state.mgbAlertSeen && @showMultiBoardGuestAlert()
      @setState
        mgbAlertSeen: true
      trackUe(
        'invite to board'
        'shows'
        'mbg alert'
        ''
        ''
        'by hovering over the guest in the dropdown'
        {
          'organizationid': @props.displayOrg?.id
          'memberid': @props.member.id
        }
      )


  onRemoveClick: (e) ->
    {
      onRemoveClick
      onShowMultiBoardGuestAlert
      member
    } = @props
    if member.blockInvite && onShowMultiBoardGuestAlert?
      onShowMultiBoardGuestAlert(false)
    onRemoveClick(e)
